import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconLeadCreatedGoal = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zM6 9.845L4 6h10l2 3.845-2 3.845H4l2-3.845z",
		fill: "#7A7370"
	})
});
export default SvgIconLeadCreatedGoal;
